module.exports = __webpack_public_path__ + "static/img/zhong9.e4686c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong9.png
// module id = O6Mb
// module chunks = 16